import {
	grayColor,
	grayColorShade_3,
	lightGreenShade_1,
	lightGreenShade_2,
	lightOrange,
	lilacColor,
	orangeShade1,
} from 'assets/jss/material-dashboard-pro-react';

export const status = {
	EXPIRED: 'Expired',
	ACTIVE: 'Active',
	PENDING: 'Pending',
	FAILED: 'Failed',
	NEW: 'New',
};

export const color = {
	[status.EXPIRED]: {
		background: grayColor[14],
		border: grayColorShade_3,
		buttonColor: grayColorShade_3,
		accordion: grayColor[14],
	},
	[status.ACTIVE]: {
		background: lightGreenShade_1,
		border: lightGreenShade_2,
		buttonColor: lightGreenShade_2,
		accordion: '',
	},
	[status.PENDING]: {
		background: lightOrange,
		border: orangeShade1,
		buttonColor: orangeShade1,
		accordion: lightOrange,
	},
	[status.NEW]: {
		background: lilacColor[0],
		border: lilacColor[1],
	},
};

export const N0_OF_DAYS_FOR_EXPIRY = 5;
export const STATUS = 'status';
export const SUCCESS = 'success';
export const FAILURE = 'failure';
export const LINK_ACTIONS = {
	CHANGE_PLAN: 'CHANGE_PLAN',
	EXTEND_PLAN: 'EXTEND_PLAN'
}
